var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('div',{staticClass:"video-container"},[_c('img',{attrs:{"src":_vm.imgSrc}}),_c('span',[_c('h2',{staticClass:"txt"},[_vm._v("Waarmee kan ik je van dienst zijn ?")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }